import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useStateContext } from "../src/contexts/ContextProvider";
import { useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";
import {
  Home,
  Signup,
  Login,
  Dashboard,
  Profile,
  Messages,
  Help,
  Rooms,
  Room,
  Error,
  Checkout,
  PaymentStatus,
  ManageSubscription,
  CheckoutSubscription,
  Account,
  StripeConnect,
  AccountReturn,
  OnboardingReturn,
  Search,
  ReportAbuse,
  Fingerprint,
} from "./pages";

function App() {
  const { isLoggedIn, navigateToDashboard, checkAuth } = useStateContext();
  const [path, setPath] = useState();

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const isTracking =
      process.env.REACT_APP_GA_TRACKING === "true" ? true : false;

    if (isTracking) {
      ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);
      console.log("Google Analytics is ON");
    } else {
      console.log("Google Analytics is OFF");
    }
  }, []);

  useEffect(() => {
    setPath(location.pathname);
    checkAuth();

    if (isLoggedIn && navigateToDashboard) {
      navigate("/dashboard");
      console.log("User is logged in...");
    }
    // eslint-disable-next-line
  }, [isLoggedIn]);

  return (
    <>
      <Routes>
        {/* Pages */}
        <Route path="/help" element={<Help />} />
        <Route path="/search" element={<Search />} />
        <Route path="/search/:city" element={<Rooms />} />
        <Route path="/rooms" element={<Rooms />} /> {/* for query params */}
        <Route path="/rooms/:uuid" element={<Room />} />
        <Route path="/404-error" element={<Error />} />
        <Route path="/payment-status" element={<PaymentStatus />} />
        <Route path="/account-return" element={<AccountReturn />} />
        <Route path="/onboarding-return" element={<OnboardingReturn />} />
        <Route path="/report-abuse/:relayId" element={<ReportAbuse />} />
        <Route path="/cyber-cit" element={<Fingerprint />} />
        <Route path="*" element={<Navigate to="/404-error" replace />} />
        {!isLoggedIn && (
          <>
            <Route path="/" element={<Home />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} />
            <Route path="/invite" element={<Login />} />
          </>
        )}
        {isLoggedIn && (
          <>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/account" element={<Account />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route
              path="/account/subscription"
              element={<ManageSubscription />}
            />
            <Route path="/account/stripe-connect" element={<StripeConnect />} />
            <Route
              path="/checkout-subscription/:subscriptionType"
              element={<CheckoutSubscription />}
            />
          </>
        )}
      </Routes>
    </>
  );
}

export default App;
